import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9r1q7fw26q: FaireBrandEntity = {
  token: "b_9r1q7fw26q",
  type: "brand",
  name: "Grill Your Ass Off - Spices, Rubs, Seasonings, Sauces, Jerky",
  avatarUrl:
    "https://cdn.faire.com/fastly/72fac4c4c10a6f7b3a0d65e57b8aa4a42be9aa3d5efd3d5254ae60b9f9dff5ad.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1411f0b7ce711fc6a31c2183a15147486dc210705d4240f4bfd22b5a55cec357.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/72fac4c4c10a6f7b3a0d65e57b8aa4a42be9aa3d5efd3d5254ae60b9f9dff5ad.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1411f0b7ce711fc6a31c2183a15147486dc210705d4240f4bfd22b5a55cec357.jpeg",
  location: "Salado, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 129,
  isInsider: true,
  description:
    "Grill Your Ass Off is a veteran-owned, Texas-based company on a mission to bring people together through the best-tasting BBQ you’ve ever had while giving back to those who’ve served. Founded by former U.S. Army Infantryman Jason Murff, every product is proudly American-made, military-themed, and crafted to spark camaraderie and laughter. With each purchase, a portion of proceeds supports The Independence Fund and other veteran and first responder organizations, empowering wounded heroes and their families to live full and independent lives.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:10.900Z",
    importedBy: "entity-db-cli",
  },
};
